import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Toggler from 'hoc/toggler'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const DatePickerDropdownDraggable = ({
  input,
  isOpen,
  toggle,
  placeholder = 'Select a date',
  groupClassName,
  inputClassName = 'text-sm text-primary-dark',
  placeholderClassName = 'text-sm',
  errorClassName,
  meta: { touched, error },
  mainClassName = 'w-full border rounded-lg p-3 cursor-pointer',
  labelClassName,
  label,
  showText = true
}) => {
  const [step, setStep] = useState(1)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const formattedDate =
    `${moment(startDate, 'MMMM D, YYYY').format('MMMM D, YYYY')} to ${moment(endDate, 'MMMM D, YYYY').format('MMMM D, YYYY')}`

  useEffect(() => {
    input.value[0] && setStartDate(new Date(input.value[0]))
    input.value[1] && setEndDate(new Date(input.value[1]))
  }, [input.value])

  // find a better approach
  const handleChange = date => {
    if (step === 1) {
      setStartDate(date)
      setEndDate(null)
      setStep(2)
    } else if (step === 2 && date >= startDate) {
      setStep(1)
      input.onChange([startDate, date])
      toggle()
    }
  }

  const renderDatePicker = () => (
    <div className="flex justify-center mt-3">
      <DatePicker
        {...input}
        minDate={new Date(2000, 1, 1)}
        startDate={startDate}
        endDate={endDate}
        selectsStart={step === 1}
        selectsEnd={step === 2}
        onChange={handleChange}
        calendarClassName="react-datepicker-removed-border-version"
        dateFormat="MMMM-d-YYYY"
        inline
      />
    </div>
  )
  return (
    <div className={groupClassName}>
      {label && <label className={`block ${labelClassName}`}>
        {label}
      </label>}
      <div className={mainClassName}>
        <div className="flex w-full justify-between items-center" onClick={toggle}>
          {startDate && endDate
            ? <p className={inputClassName}>{formattedDate}</p>
            : <p className={placeholderClassName}>{placeholder}</p>
          }
          {showText && <span className={`text-xs ${isOpen ? 'text-primary-lightgray' : 'text-primary-orange'}`}>
            Select a date
          </span>}
          {!showText && (isOpen ? <i className="fa fa-angle-up" aria-hidden="true"></i> : <i className="fa fa-angle-down" aria-hidden="true"></i>)}
        </div>
        {isOpen && renderDatePicker()}
      </div>
      {touched && error && <p className={errorClassName}>{error}</p>}
    </div>
  )
}
DatePickerDropdownDraggable.propTypes = {
  options: PropTypes.array,
  input: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  placeholderClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  meta: PropTypes.object.isRequired,
  mainClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  showText: PropTypes.bool,
}
export default Toggler(DatePickerDropdownDraggable)
